// removed by extract-text-webpack-plugin
module.exports = {"image":"image__image_2j8F9"};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/image/styles.less
// module id = ./src/client/components/image/styles.less
// module chunks = comics